import React, { useState, useEffect, useCallback } from "react";
import "./MainSectionPhoto.css";

function MainSectionPhoto() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isGalleryView, setIsGalleryView] = useState(false);

  // Usa percorsi relativi alla cartella public
  const galleryImages = Array.from({ length: 43 }, (_, i) => {
    const num = i + 1;
    return {
      src: `/Assets/positanonboard${num}.webp`,
      alt: `Positano On Board photo ${num}`
    };
  });

  const goToPrev = () => {
    setCurrentIndex(prev => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const goToNext = useCallback(() => {
    setCurrentIndex(prev => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  }, [galleryImages.length]);

  const toggleView = () => {
    setIsGalleryView(prev => !prev);
  };

  useEffect(() => {
    const interval = setInterval(goToNext, 5000);
    return () => clearInterval(interval);
  }, [goToNext]);

  return (
    <section id="Photo" className="gallery-section">
      <div className="container">
        <h1 className="heading">Photo Gallery</h1>
        
        <button
          onClick={toggleView}
          className="toggle-view-btn"
          aria-pressed={isGalleryView}
          aria-label={isGalleryView ? "Switch to slider view" : "Switch to grid view"}
        >
          {isGalleryView ? 'View as Slider' : 'View as Grid'}
        </button>

        {isGalleryView ? (
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div className="gallery-item" key={index}>
                <img
                  className="gallery-image"
                  src={image.src}
                  alt={image.alt}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="gallery-slider">
            <div className="slider">
              <button
                className="slider-button left"
                onClick={goToPrev}
                aria-label="Previous image"
              >
                &#10094;
              </button>
              
              <div className="slide active">
                <img
                  src={galleryImages[currentIndex].src}
                  alt={galleryImages[currentIndex].alt}
                  className="slider-image"
                />
                <div className="slider-caption">{galleryImages[currentIndex].alt}</div>
              </div>
              
              <button
                className="slider-button right"
                onClick={goToNext}
                aria-label="Next image"
              >
                &#10095;
              </button>
            </div>
            
            <div className="slider-indicators">
              {galleryImages.map((_, index) => (
                <span
                  key={index}
                  role="button"
                  aria-label={`Go to slide ${index + 1}`}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                ></span>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default MainSectionPhoto;
